import * as types from './types';

const INITIAL_STATE = {
  isDragging: false,
  meta: {},
};

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case types.COMMON_SET_IS_DRAGGING:
      return {
        ...state,
        isDragging: payload.isDragging,
        meta: payload.meta,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/state/dragAndDrop/reducer.js